<ejs-grid #grid class="grid-with-toolbar grid-no-filter grid-configuration" width="100%" rowHeight="38"
  [dataSource]="data" [allowSorting]="true" [allowPaging]="true" [pageSettings]='pageSettings' [allowFiltering]="true"
  [filterSettings]="filterSettings" (rowSelected)="onRowSelected($event)" (dataBound)="onDataBound()">
  <e-columns>
    <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
    <e-column field="client.Name"
      headerText="{{'i18n.domain.export-configuration.configurations.overview.column-headers.client' | translate}}"
      clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{data.clientName}} ({{data.clientNumber}})
      </ng-template>
    </e-column>
    <e-column field="configurationName"
      headerText="{{'i18n.domain.export-configuration.configurations.overview.column-headers.name' | translate}}"
      clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{data.configurationName}} - {{getTransferTypeName(data.transferType) | translate}} ({{data.id}})
      </ng-template>
    </e-column>
    <e-column field="type"
      headerText="{{'i18n.domain.export-configuration.configurations.overview.column-headers.type' | translate}}"
      clipMode="EllipsisWithTooltip" width="110px">
      <ng-template #template let-data>
        {{getTypeName(data.type) | translate}}
      </ng-template>
    </e-column>
    <e-column [headerText]="'i18n.shared.fields.active' | translate" field="active" width="90px">
      <ng-template #filterItemTemplate let-data>{{formatIsActive(data)}}</ng-template>
      <ng-template #template let-data>
        @if(data.active){
          <div class="e-icons icon-checkmark align-middle"></div>
        }
      </ng-template>
    </e-column>
  </e-columns>
</ejs-grid>
